import { ActionField, withForm } from '@oscar/form';
import { Button, Modal, notification, Typography } from '@oscar/theme';
import { APIS } from 'common/constants/endpoints';
import React from 'react';

const { Title } = Typography;

export type DeletePopupProps = {
  isVisible: boolean;
  handleCancel: () => void;
  record?: any;
  actionTable?: any;
};

const DeletePopup: React.FC<DeletePopupProps> = ({
  isVisible,
  handleCancel,
  record,
  actionTable,
}) => {
  const showMessage = (code: number) => {
    if (code === 1) {
      notification['success']({
        message: 'Successfully!',
        description: 'User has been deleted',
      });
    }
    if (code === 2) {
      notification['error']({
        message: 'Delete user error',
      });
    }
  };

  return (
    <ActionField
      name={'deleteUserManagement'}
      request={{
        name: 'Save',
        url: APIS.DELETE_USER,
        method: 'DELETE',
        params: {
          userId: record?.userId,
        },
      }}
      onResponseData={(res: any) => {
        showMessage(res?.code);
        if (res?.code === 1) {
          actionTable?.fetchData?.({});
          handleCancel();
        }
      }}
    >
      {(actionProps: any) => {
        return (
          <Modal
            className="popup-custom"
            title="Delete confirmation"
            maskTransitionName=""
            visible={isVisible}
            onCancel={() => handleCancel()}
            footer={[
              <Button size="middle" key="back" onClick={() => handleCancel()}>
                Cancel
              </Button>,
              <Button
                className="btn-submit"
                size="middle"
                key="submit"
                onClick={() => {
                  actionProps.submitData();
                }}
              >
                Confirm
              </Button>,
            ]}
          >
            <Title level={5}>Are you sure you want to delete this user?</Title>
          </Modal>
        );
      }}
    </ActionField>
  );
};

export default withForm<DeletePopupProps>({
  name: 'company',
  preload: [],
})(DeletePopup);
